/* eslint-disable i18next/no-literal-string */
import React from 'react';
import '../../styles/components/AsperaTabs.scss';
import { withRouter } from 'react-router-dom';
import { Tabs, Tab, TabList } from '../Carbon';
import { tracking } from '../../services/TrackingService';
import { AsperaErrorState } from '../AsperaErrorState';
import { language } from '../../services/LanguageService';
import { AsperaError } from '../../classes/AsperaError';
/**
 * React Component
 *
 * The AsperaTabs renders the tabs via a simple array
 *
 * @example
 * ```javascript
 * <AsperaTabs items={this.tabs} />
 * ```
 */
export const AsperaTabs = withRouter(class AsperaTabs extends React.Component {
    constructor() {
        super(...arguments);
        this.handleFinalClick = (tab, _event) => {
            const { history } = this.props;
            if (typeof tab.onClick === 'function') {
                tab.onClick(tab);
            }
            if (typeof tab.route === 'string') {
                history.push(tab.route);
            }
            tracking.track('Navigate UI', { action: 'Clicked Tab Item', actionType: tab.name, successFlag: true });
        };
        this.handleClick = (tab, event) => {
            event.preventDefault();
            tracking.checkDirtyForms(() => this.handleFinalClick(tab, event));
        };
    }
    get notFoundPage() {
        return (React.createElement("div", { className: "cds--grid error-wrapping cds--tab-content" },
            React.createElement(AsperaErrorState, { type: "404", title: language.get('errors.pageNotFound'), body: language.get('errors.pageNotFoundDescription') })));
    }
    getTabs() {
        const { items, location, overrideActiveIndex } = this.props;
        let componentToLoad;
        /** Indicate if any tabs have a view. This is used for knowing if tab is not present but is a valid route (for 404) */
        let someTabsHaveView = false;
        let foundActiveTab = false;
        let currentTab;
        if (Array.isArray(items)) {
            /** Current tab is initially -1 as Carbon makes first one selected if undefined or false or 0.  So using -1 to avoid first showing active  */
            let current = 0;
            const tabsToRender = items.filter(tab => !tab.hidden);
            tabsToRender.forEach((tab, index) => {
                if (tab.views)
                    someTabsHaveView = true;
                const fullPath = `${location.pathname}${location.hash}`.toLowerCase();
                if (tab.route && (tab.exact ? fullPath === tab.route.toLowerCase() : fullPath.indexOf(tab.route.toLowerCase()) > -1)) {
                    tab.active = true;
                    currentTab = tab;
                    foundActiveTab = true;
                    const relativePath = fullPath.replace(tab.route.toLowerCase(), '');
                    if (Array.isArray(tab.views)) {
                        tab.views.forEach(view => {
                            const testPath = view.path ? view.path.toLowerCase() : '';
                            if (!relativePath && !testPath) {
                                componentToLoad = view.component;
                            }
                            else if (relativePath === testPath) {
                                componentToLoad = view.component;
                            }
                            else if (testPath.indexOf('*') > -1) {
                                const regex = `^${testPath.replace(/\//g, '\\/').replace(/\*/g, '.+')}$`;
                                if (relativePath.match(regex)) {
                                    componentToLoad = view.component;
                                }
                            }
                        });
                    }
                    current = index;
                }
            });
            return (React.createElement(React.Fragment, null,
                React.createElement(Tabs, { selectedIndex: typeof overrideActiveIndex === 'number' ? overrideActiveIndex : current },
                    React.createElement(TabList, { activation: "manual", "aria-label": "" }, tabsToRender.map((tab, index) => {
                        return (React.createElement(Tab, { "data-auto": `tabs-item-${tab.route || tab.name}`, key: index, onClick: (event) => {
                                this.handleClick(tab, event);
                            } }, tab.name));
                    })),
                    React.createElement("div", { className: "aspera-tab-content" },
                        (!!componentToLoad && (currentTab === null || currentTab === void 0 ? void 0 : currentTab.active)) && componentToLoad,
                        (!componentToLoad && (currentTab === null || currentTab === void 0 ? void 0 : currentTab.active) && (currentTab === null || currentTab === void 0 ? void 0 : currentTab.views)) && this.notFoundPage)),
                React.createElement("div", { className: "aspera-tab-content" }, !!(!componentToLoad && someTabsHaveView && !foundActiveTab) && this.notFoundPage)));
        }
    }
    componentDidCatch(error) {
        new AsperaError('AsperaTabs: Encountered exception from children', error);
        this.setState({});
    }
    render() {
        const { className } = this.props;
        return (React.createElement("div", { className: `aspera-tabs ${className ? className : ''}`, "data-auto": "tabs-wrapper" }, this.getTabs()));
    }
});
